import React, { useState, useEffect } from 'react';
import { Select, Spin } from 'antd';
import { useQuery } from 'react-query';
import { customerService } from '../../services/customerService';
import debounce from 'lodash/debounce';

const { Option } = Select;

interface CustomerSelectProps {
  value?: string | number;
  onChange?: (value: string | number, customer?: any) => void;
  placeholder?: string;
  allowClear?: boolean;
  disabled?: boolean;
  style?: React.CSSProperties;
  onCustomersLoaded?: (customers: any[]) => void;
}

const CustomerSelect: React.FC<CustomerSelectProps> = ({
  value,
  onChange,
  placeholder = 'Chọn khách hàng',
  allowClear = true,
  disabled = false,
  style,
  onCustomersLoaded
}) => {
  const [searchText, setSearchText] = useState('');

  // Fetch customers for select
  const { data: customers = [], isLoading } = useQuery(
    ['customers-select', searchText],
    () => customerService.getCustomersForSelect({ search: searchText }),
    {
      staleTime: 5 * 60 * 1000,
      enabled: !disabled,
      onSuccess: (data) => {
        console.log('CustomerSelect onSuccess:', data);
        // Notify parent component when customers are loaded
        onCustomersLoaded?.(data);
      },
    }
  );

  // Debug customers data
  useEffect(() => {
    console.log('CustomerSelect customers data:', customers);
  }, [customers]);

  // Debounced search
  const debouncedSearch = debounce((value: string) => {
    setSearchText(value);
  }, 300);

  const handleSearch = (value: string) => {
    debouncedSearch(value);
  };

  const handleChange = (selectedValue: string | number) => {
    const selectedCustomer = customers.find((c: any) => c.id === selectedValue);
    onChange?.(selectedValue, selectedCustomer);
  };

  return (
    <Select
      value={value}
      onChange={handleChange}
      placeholder={placeholder}
      allowClear={allowClear}
      disabled={disabled}
      style={{
        ...style,
        width: '100%'
      }}
      showSearch
      filterOption={false}
      onSearch={handleSearch}
      notFoundContent={isLoading ? <Spin size="small" /> : 'Không tìm thấy khách hàng'}
      loading={isLoading}
      optionLabelProp="label"
      dropdownStyle={{ zIndex: 1001 }}
    >
      {customers.map((customer: any) => (
        <Option 
          key={customer.id} 
          value={parseInt(customer.id)}
          label={customer.name}
        >
          <div style={{ padding: '4px 0' }}>
            <div style={{ fontWeight: 'bold', fontSize: '14px' }}>{customer.name}</div>
            <div style={{ fontSize: '12px', color: '#666', marginTop: '2px' }}>
              {customer.code} - {customer.phone || 'Chưa có SĐT'}
            </div>
          </div>
        </Option>
      ))}
    </Select>
  );
};

export default CustomerSelect; 